import React from "react";
import Graduate from "../asset/graduate.webp";
import Freelance from "../asset/freelance.webp";
import Hacker from "../asset/hacker-cover.webp";
import Drop from "../asset/drop.gif";
import Lead from "../asset/lead.webp";


class CardArticles extends React.Component {
  render() {
    return (
      <div className="row">
        <div className="col-12 col-md-4 mb-3 ">
                       <div className="h-100 card-articles">
                         <img src={Lead} className="card-img-top pb-2" alt="example" />
                         <div className="card-body">
                           <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
                             Mencoba Jadi <span className="font-green">Team Lead</span>{" "}
                             Dalam Satu Bulan 👾.
                           </h6>
                           <p className="card-text text-grey clamp-2-lines">
                             Di suatu hari yang tidak terduga, saya seorang anomali, dipercaya untuk menjadi Team Lead dalam kurang waktu 1 bulan, apa yang terjadi :u ?
                           </p>
       
                           <a href="/mencoba-jadi-team-lead-satu-bulan">
                             <button className="btn btn-sm btn-base">Read</button>
                           </a>
                         </div>
                       </div>
                     </div>
         <div className="col-12 col-md-4 mb-3 ">
          <div className="h-100 card-articles">
            <img
              src={Drop}
              className="card-img-top pb-2"
              alt="example"
            />
            <div className="card-body">
              <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
             Drop <span className="font-green">Javascript</span> Phising On Windows 😃.
              </h6>
              <p className="card-text text-grey clamp-2-lines">
                Mungkin yang kalian tau javascript running di content web ? bagaimana javascript berjalan pada windows, dan justru membuat malware yang mengatantarkan phising attack ?
              </p>

              <a href="/drop-js-phising-on-windows"><button className="btn btn-sm btn-base">Read</button></a>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 mb-3 ">
          <div className="h-100 card-articles">
            <img
              src={Hacker}
              className="card-img-top pb-2"
              alt="example"
            />
            <div className="card-body">
              <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
             Jadi <span className="font-green">Hacker</span> Kaya Di film-film 👽.
              </h6>
              <p className="card-text text-grey clamp-2-lines">
                Tidak pernah terfikir saya melakukan apa yang hacker lakukan di film-film, tapi in real life.
              </p>

              <a href="/jadi-hacker-kaya-di-film"><button className="btn btn-sm btn-base">Read</button></a>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 mb-3 ">
          <div className="h-100 card-articles">
            <img
              src={Freelance}
              className="card-img-top pb-2"
              alt="example"
            />
            <div className="card-body">
              <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
              Membuka Hasil  <span className="font-green">Tabungan Freelance</span> 650 Jam 👻.
              </h6>
              <p className="card-text text-grey clamp-2-lines">
                Setelah melakukan freelance 650 Jam, akhirnya saya memutuskan menulis ini untuk memotivasi saya lebih semangat.
              </p>

              <a href="/membuka-hasil-tabungan-freelance"><button className="btn btn-sm btn-base">Read</button></a>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 mb-3 ">
          <div className="h-100 card-articles">
            <img
              src={Graduate}
              className="card-img-top pb-2"
              alt="example"
            />
            <div className="card-body">
              <h6 className="card-title pb-1 pt-1 font-PoppinsBold">
              Life  <span className="font-green">After</span> Graduate 🎓🏄🏻‍♂️.
              </h6>
              <p className="card-text text-grey clamp-2-lines">
                Tidak terasa journey kuliah berlalu sangat cepat, 7 bulan resmi kehidupan setelah lulus dimulai.
              </p>

              <a href="/life-after-graduate"><button className="btn btn-sm btn-base">Read</button></a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CardArticles;
